/**
 * Toast.jsx
 * Auto-dismissing notification shown in the bottom-right corner.
 * Displays for 2.2 seconds (an error 4.5s, so it can be read), then fades out
 * and calls onDone.
 *
 * @param {string}   message — Text to display
 * @param {string}   tone    — 'error' for a refusal (red, no checkmark)
 * @param {function} onDone  — Called after the toast finishes its exit animation
 */
import { useEffect, useState } from 'react';

export const Toast = ({ message, onDone, tone }) => {
  const [visible, setVisible] = useState(true);
  const error = tone === 'error';

  useEffect(() => {
    const t = setTimeout(
      () => {
        setVisible(false);
        setTimeout(onDone, 300);
      },
      error ? 4500 : 2200
    );
    return () => clearTimeout(t);
  }, [onDone, error]);

  return (
    <div
      className="go-toast-in"
      style={{
        position: 'fixed',
        bottom: 28,
        right: 28,
        zIndex: 2000,
        background: error ? '#B71C1C' : '#1B5E20',
        color: '#fff',
        borderRadius: 8,
        padding: '12px 20px',
        fontSize: 12,
        fontWeight: 700,
        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s',
        fontFamily: 'Montserrat',
      }}
    >
      <span style={{ fontSize: 16 }}>{error ? '!' : '✓'}</span> {message}
    </div>
  );
};
